import { useEffect, useRef, useState } from 'react';
import { useParams, useLocation } from "react-router-dom"
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { SELF as key } from 'constants/keys';
import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';
import { Tabs } from 'antd'; // Add this import
import reducer from './reducer';
import saga from './saga';
import { getSelfDataRequest, getReportDataRequest, getUserAttemptsRequest } from "./action";
import { selectSelfDataList, selectIsLoading, selectReportData, selectUserAttempts, selectUserAttemptsLoading } from "./selector";
import SubFooterComponent from "components/SubFooterComponent";
import { Container, TopContainer, SelfContainer} from "./styled";
import ProgressSubHeader from 'components/ProgressSubHeader';
import HazmatImage from 'components/icons/hazmat';
import HazmatProgress from 'components/HazmatProgress';

import ulmManual from "assets/documents/ULM.pdf";

const printStyle = `
    @media print {
        @page {
            size: A4 landscape;
            margin-top: 10mm;
        }  
        .ant-table-thead > tr > th,
        .ant-table-tbody > tr > td {
            font-size: 10px;
            line-height: 0.3;
            
        }
        .hazmat-chart-1 {
            transform: scale(0.65);
            transform-origin: 0 0;
        }
        .hazmat-chart-2 {
            transform: scale(0.65);
            transform-origin: 0 0;
        }
    }
`

const HazmatContainer = (props) => {
    const { 
        getSelfDataRequest, 
        getReportDataRequest, 
        getUserAttemptsRequest, 
        selfDataList, 
        reportData, 
        isLoading, 
        userAttempts,
        userAttemptsLoading 
    } = props;
    const { id: vr_app_session } = useParams();
    const location = useLocation();
    const [currentUserId, setCurrentUserId] = useState(null);
    const printRef = useRef(null);
    const [activeTab, setActiveTab] = useState('1'); // Add this line

    useInjectReducer({key, reducer});
	useInjectSaga({key, saga});

    useEffect(() => {
        if(vr_app_session) {
            getSelfDataRequest({vr_app_session});
        }
    }, [vr_app_session, getSelfDataRequest]);

    useEffect(() => {
        if (selfDataList && selfDataList.attemptResult && selfDataList.attemptResult.user) {
            setCurrentUserId(selfDataList.attemptResult.user.id);
        }
    }, [selfDataList]);

    useEffect(() => {
        if (currentUserId && selfDataList && selfDataList.training) {
            getUserAttemptsRequest({
                trainingId: selfDataList.training.id,
                userId: currentUserId
            });
        }
    }, [currentUserId, selfDataList, getUserAttemptsRequest]);

    useEffect(() => {
        getReportDataRequest({ vr_app_session, userId: currentUserId });
    }, [currentUserId, vr_app_session, getReportDataRequest]);

    const handleReloadData = () => {
        if(vr_app_session) {
            getSelfDataRequest({vr_app_session});
            // need user id to get report data?
            // getReportDataRequest({ vr_app_session, currentUserId });
        }
    }

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    return (
        <Container>
            <ProgressSubHeader 
                title="Precimar ULM 600-E" 
                printRef={printRef} 
                style={{fontSize: "24px", fontWeight: 800}} 
                printStyle={printStyle}
                handleReloadData={handleReloadData}
            />
            <TopContainer >
                <SelfContainer>
                    <Tabs activeKey={activeTab} onChange={handleTabChange} >
                        <Tabs.TabPane tab="Data" key="1">
                            <HazmatProgress 
                                dataList={selfDataList} 
                                reportData={reportData}
                                isLoading={isLoading}
                                getReportData={getReportDataRequest}
                                getSelfDataRequest={getSelfDataRequest}
                                getUserAttemptsRequest={getUserAttemptsRequest}
                                userAttempts={userAttempts}
                                userAttemptsLoading={userAttemptsLoading}
                                printRef={printRef}
                                currentUserId={currentUserId}
                                vr_app_session={vr_app_session}
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Manual" key="2">
                            <iframe 
                                src={ulmManual} 
                                title="ULM Manual" 
                                width="100%"
                                height="100%"
                                style={{ width: '100%', height: '600px' }}
                            />
                        </Tabs.TabPane>
                    </Tabs>
                </SelfContainer>
                <SubFooterComponent />
            </TopContainer>
        </Container>
    );
}

const mapStateToProps = createStructuredSelector({
    isLoading: selectIsLoading(),
    selfDataList: selectSelfDataList(),
    reportData: selectReportData(),
    userAttempts: selectUserAttempts(),
    userAttemptsLoading: selectUserAttemptsLoading(),
});

const mapDispatchToProps = (dispatch) => ({
    getSelfDataRequest: (data) => dispatch(getSelfDataRequest(data)),
    getReportDataRequest: (data) => dispatch(getReportDataRequest(data)),
    getUserAttemptsRequest: (data) => dispatch(getUserAttemptsRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HazmatContainer);